// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * Component capable of rendering the `EmbedModule`
 * with the version set to `EmbedVersion.Iframe`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let EmbedIframeUi = class EmbedIframeUi extends Vue {
    /**
     * Protects you from accessing an undefined variable.
     *
     * @returns - `this.iframe` if it exists
     * @returns - Empty string, if this.iframe hasn't been defined or is broken.
     */
    get html() {
        return typeof this.iframe === 'string' && this.iframe.length > 0
            ? this.iframe
            : '';
    }
};
__decorate([
    Prop({ type: String, required: false })
], EmbedIframeUi.prototype, "description", void 0);
__decorate([
    Prop({ type: String, required: true })
], EmbedIframeUi.prototype, "iframe", void 0);
EmbedIframeUi = __decorate([
    Component({
        name: 'EmbedIframeUi',
        mounted() {
            this.$emit('ready');
        },
        template: `
    <figure>
      <div v-html="html" />
      <figcaption v-if="description" class="small">{{ description }}</figcaption>
    </figure>
  `
    })
], EmbedIframeUi);
export { EmbedIframeUi };
